
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer } from 'recharts';

interface CategoryChartProps {
  data: {
    name: string;
    value: number;
    fill: string;
  }[];
}

const CategoryChart: React.FC<CategoryChartProps> = ({ data }) => {
  if (data.length === 0) return <p className="text-gray-500 italic">No category data available</p>;
  
  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
      <h3 className="text-sm font-medium mb-3">Top Categories</h3>
      <div className="h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="name" type="category" width={80} />
            <Tooltip
              formatter={(value: number) => [`${value} items`, 'Count']}
              contentStyle={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '4px' }}
            />
            <Bar dataKey="value" radius={[0, 4, 4, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CategoryChart;
